import { useEffect, useState } from 'react';
import axiosClient from '../../axios-client.js';

import NavLink from './UIBTN/NavLink'

import { Navbar, Nav, Button } from 'react-bootstrap';
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { useStateContext } from '../context/ContextProvider'
import logo from '../assets/svg/logo.svg'
import userIcon from '../assets/svg/user-ic.svg'
import messageIcon from '../assets/svg/menu/ic-message.svg'
import plusIcon from '../assets/svg/plus-ic.svg'
import icBrodcastList from '../assets/svg/ic-brodcast.svg'
import icListConfirm from '../assets/svg/ic-listConfirm.svg'
import icCredit from '../assets/svg/ic-credit.svg'
import iclogout from '../assets/svg/ic-logout.svg'
import BuyCredits from '../views/credit/BuyCredits';
import Footer from '../views/footer/Footer.jsx';
import icVerify from '../assets/png/fingerprint-verification-on-mobile-phone.png'

const DefaultLayout = () => {

    // Crdit modal
    const [showCredit, setShowCredit] = useState(false);

    const [credit, setCredit] = useState(0);
    const [fullName, setfullName] = useState();
    const [ loading, setLoading ] = useState(false);
    const [credits, setCredits] = useState(0);
    const [ verify, setVirify ] = useState();
    const [broadcasts, setBroadcasts] = useState([]);
    const [allConfirmations, setAllConfirmations] = useState([]);

    const { slug } = useParams();

    const handleShowCredit = () => {
        setShowCredit(true);
    };

    const handleCloseCredit = () => {
        setShowCredit(false);
    };

    const { user, token } = useStateContext();

    if (!token) {
        return slug ? <Navigate to={`/${slug}`} /> : <Navigate to='/login' />;
    }

    const logOut = () => {
        localStorage.clear();
        window.location.href = '/';
    };

    useEffect(() => {
        userInfo();
        fetchData();
        fetchBroadcast();
    }, [])

    const userInfo = async () => {
        setLoading(true);
        try {
            const { data } = await axiosClient.get('/user');
            setVirify(data.data.phone_verified_at);
            setCredits(data.data.credit.credit);
            var sifrtName = data.data.name.split(' ');
            setfullName(sifrtName[0]);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching user information:', error);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axiosClient.get(`/broadcasts`);
            const responseData = response.data.data;
            setBroadcasts(responseData.broadcasts);
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    const fetchBroadcast = async () => {
        try {
            const response = await axiosClient.get(`/confirmations`);
            const responseData = response.data.data;
            setAllConfirmations(responseData.paid_messages.confirmations)
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
        
    };

    return (
        <div id='defaultLayout'>
            {loading ? <>
                <div className='align-items-center  justify-content-center'>
                    <div className='d-flex align-items-center  justify-content-center atext-center p-5 vh-90'>
                        <h6 className='fw-bold'>Loading...</h6>
                    </div>
                </div>
            </> : !verify ?
                <div>
                    <Navbar bg='white' variant='white' expand='lg'>
                        <div className='container-fluid'>
                            <Navbar.Brand href='/'>
                                <img className='logo' src={logo} />
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls='basic-navbar-nav' />
                            <Navbar.Collapse id='basic-navbar-nav'>
                                <Nav className='me-auto'>
                                </Nav>
                                <Navbar className='navbar-nav my-lg-0 navbar-nav-scroll'>

                                    <Button className='bg-user nav-link py-1 text-start px-1 rounded-pill mx-1'>
                                        <div className='d-flex align-items-center'>
                                            <img width={38} height={38} src={userIcon} />
                                            <span className='px-2'>
                                                {loading ? (
                                                    <span>Loading..</span>
                                                ) : (
                                                    <>{fullName}</>

                                                )}
                                            </span>
                                        </div>
                                    </Button>

                                    <Button onClick={logOut} className='bg-transparent nav-link py-1 text-start p-0 rounded-pill mx-1'>
                                        <div className='d-flex align-items-center'>
                                            <img src={iclogout} />
                                        </div>
                                    </Button>
                                </Navbar>
                            </Navbar.Collapse>
                        </div>
                    </Navbar>
                    {slug ? <></> : <div className='d-flex align-items-center  justify-content-center atext-center p-5 vh-85'>
                        <div className='text-center fw-bold'>
                            <h4 className='fw-bold pb-3'>Please verify your Whastapp number</h4>
                            <h5 className='fw-bold'> We have sent an activation link to your number via WhatsApp message.</h5>
                            <img height={400} className='p-2' src={icVerify} />
                            <p className='fw-bold'>If you have troubles confirming your account, send an email to <a href='mailto:admin@1confirmed.com'>admin@1confirmed.com</a> </p>
                        </div>
                    </div>}

                </div>
                : <><BuyCredits show={showCredit} handleClose={handleCloseCredit} />
                    <Navbar bg='white' variant='white' expand='lg'>
                        <div className='container-fluid'>
                            <Navbar.Brand href='/'>
                                <img className='logo' src={logo} />
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls='basic-navbar-nav' />
                            <Navbar.Collapse id='basic-navbar-nav'>
                                <Nav className='me-auto'>
                                </Nav>
                                <Navbar className='navbar-nav my-lg-0 navbar-nav-scroll'>
                                    <NavLink
                                        to={'/new-message'}
                                        title='New message'
                                        icon={messageIcon}
                                        className={'bg-msg'}
                                    />
                                    <Button href='/new-broadcast' className='bg-brodcast nav-link py-1 text-start px-1 rounded-pill mx-1'>
                                        <div className='d-flex align-items-center'>
                                            <img width={38} height={38} src={plusIcon} />
                                            <span className='px-2 bg-brodcast'>New Broadcast</span>
                                        </div>
                                    </Button>
                                    {broadcasts.length > 0 && (
                                        <NavLink to='/all-broadcasts' title='All Broadcasts' icon={icBrodcastList} className={'bg-allbrodcast'} />
                                    )}
                                    { allConfirmations.length > 0 && (
                                      <NavLink to='/all-confimations' title='All Confirmations' icon={icListConfirm} className={'bg-allconfirm'}/>      
                                    )}
                                    <Button className={'m-0 p-0 bg-credit nav-link py-1 text-start px-1 rounded-pill mx-1'} onClick={handleShowCredit}>
                                        <div className='d-flex align-items-center'>
                                            <img width={38} height={38} src={icCredit} />
                                            {loading ? (
                                                <span>Loading..</span>
                                            ) : (
                                                <span className='px-2'>
                                                    {credits} Credits
                                                </span>
                                            )}
                                        </div>
                                    </Button>

                                    <Button className='bg-user nav-link py-1 text-start px-1 rounded-pill mx-1'>
                                        <div className='d-flex align-items-center'>
                                            <img width={38} height={38} src={userIcon} />
                                            <span className='px-2'>
                                                {loading ? (
                                                    <span>Loading..</span>
                                                ) : (
                                                    <>{fullName}</>

                                                )}
                                            </span>
                                        </div>
                                    </Button>

                                    <Button onClick={logOut} className='bg-transparent nav-link py-1 text-start p-0 rounded-pill mx-1'>
                                        <div className='d-flex align-items-center'>
                                            <img src={iclogout} />
                                        </div>
                                    </Button>
                                </Navbar>
                            </Navbar.Collapse>
                        </div>
                    </Navbar>
                    <Outlet context={{ credits, setCredits }} />
                </>}

            {!slug ? <Footer /> : <></>}
        </div>
    )
}


export default DefaultLayout